import { MatsInfo } from "@mezo/api"
import { createSlice } from "@reduxjs/toolkit"

import { AccountCreationStatus } from "#/shared/types"

type ContactIdentifiers = {
  email: string | null
  telegram: string | null
}

export type AccountState = {
  authId: string | null
  username: string
  accountCreationStatus: AccountCreationStatus
  hasModifiedUsername: boolean
  mats: Omit<MatsInfo, "address">
  contactIdentifiers: ContactIdentifiers
  loadingAccountData: boolean
}

const initialMats: Omit<MatsInfo, "address"> = {
  totalMats: 0,
  matsFromDeposits: 0,
  matsFromReferrals: 0,
  matsFromSecondaryReferrals: 0,
  netMatsTransferred: 0,
  dailyMats: 0,
  dailyMatsFromDeposits: 0,
  dailyMatsFromReferrals: 0,
  dailyMatsFromSecondaryReferrals: 0,
}

const initialState: AccountState = {
  authId: null,
  username: "",
  accountCreationStatus: AccountCreationStatus.Idle,
  hasModifiedUsername: false,
  mats: initialMats,
  contactIdentifiers: { email: null, telegram: null },
  loadingAccountData: false,
}

const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setMats: (
      immerState,
      { payload }: { payload: Omit<MatsInfo, "address"> },
    ) => {
      immerState.mats = payload
    },
    setUsername: (immerState, { payload }: { payload: string }) => {
      immerState.username = payload
    },
    setUserAuthId: (immerState, { payload }: { payload: string | null }) => {
      immerState.authId = payload
    },
    setHasModifiedUsername: (immerState, { payload }: { payload: boolean }) => {
      immerState.hasModifiedUsername = payload
    },
    setContactIdentifer: (
      immerState,
      { payload }: { payload: ContactIdentifiers },
    ) => {
      immerState.contactIdentifiers = payload
    },
    setAccountCreationStatus: (
      immerState,
      { payload }: { payload: AccountCreationStatus },
    ) => {
      immerState.accountCreationStatus = payload
    },
    setLoadingAccountData: (immerState, { payload }: { payload: boolean }) => {
      immerState.loadingAccountData = payload
    },
    resetAccount: () => initialState,
  },
})

export const {
  setUsername,
  setUserAuthId,
  setMats,
  setHasModifiedUsername,
  setContactIdentifer,
  setAccountCreationStatus,
  setLoadingAccountData,
  resetAccount,
} = accountSlice.actions

export default accountSlice.reducer
